"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
exports.ApolloContext = React.createContext &&
    React.createContext(undefined);
//# sourceMappingURL=ApolloContext.js.map